import QuestionList from './QuestionList';

export default QuestionList;
